/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CreateCustomersFromOrdersErrorDtoModel, CreateCustomersFromOrdersErrorDtoModelType } from "./CreateCustomersFromOrdersErrorDtoModel"
import { CreateCustomersFromOrdersErrorDtoModelSelector } from "./CreateCustomersFromOrdersErrorDtoModel.base"
import { CreatedCustomerWithOrderDtoModel, CreatedCustomerWithOrderDtoModelType } from "./CreatedCustomerWithOrderDtoModel"
import { CreatedCustomerWithOrderDtoModelSelector } from "./CreatedCustomerWithOrderDtoModel.base"
import { SkippedOrderDtoModel, SkippedOrderDtoModelType } from "./SkippedOrderDtoModel"
import { SkippedOrderDtoModelSelector } from "./SkippedOrderDtoModel.base"
import { RootStoreType } from "./index"


/**
 * CreateCustomersFromOrdersResultDtoBase
 * auto generated base class for the model CreateCustomersFromOrdersResultDtoModel.
 */
export const CreateCustomersFromOrdersResultDtoModelBase = ModelBase
  .named('CreateCustomersFromOrdersResultDto')
  .props({
    __typename: types.optional(types.literal("CreateCustomersFromOrdersResultDto"), "CreateCustomersFromOrdersResultDto"),
    createdCustomers: types.union(types.undefined, types.array(types.late((): any => CreatedCustomerWithOrderDtoModel))),
    skippedOrders: types.union(types.undefined, types.array(types.late((): any => SkippedOrderDtoModel))),
    error: types.union(types.undefined, types.null, types.late((): any => CreateCustomersFromOrdersErrorDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CreateCustomersFromOrdersResultDtoModelSelector extends QueryBuilder {
  createdCustomers(builder: string | CreatedCustomerWithOrderDtoModelSelector | ((selector: CreatedCustomerWithOrderDtoModelSelector) => CreatedCustomerWithOrderDtoModelSelector) | undefined) { return this.__child(`createdCustomers`, CreatedCustomerWithOrderDtoModelSelector, builder) }
  skippedOrders(builder: string | SkippedOrderDtoModelSelector | ((selector: SkippedOrderDtoModelSelector) => SkippedOrderDtoModelSelector) | undefined) { return this.__child(`skippedOrders`, SkippedOrderDtoModelSelector, builder) }
  error(builder: string | CreateCustomersFromOrdersErrorDtoModelSelector | ((selector: CreateCustomersFromOrdersErrorDtoModelSelector) => CreateCustomersFromOrdersErrorDtoModelSelector) | undefined) { return this.__child(`error`, CreateCustomersFromOrdersErrorDtoModelSelector, builder) }
}
export function selectFromCreateCustomersFromOrdersResultDto() {
  return new CreateCustomersFromOrdersResultDtoModelSelector()
}

export const createCustomersFromOrdersResultDtoModelPrimitives = selectFromCreateCustomersFromOrdersResultDto()
